export default {
  items: [

    {
      name: 'Accueil',
      url: '/pages/home',
      icon: 'fa fa-home'
    },
    {
      name: 'Se connecter',
      url: '/pages/login',
      icon: 'fa fa-sign-in'
    },
    {
      name: 'S\'inscrire',
      url: '/pages/register',
      icon: 'fa fa-envelope'
    },
  ]
}
